import { FormattedMessage } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import "./adsbanners.css";

function TokensBanner() {
  const display = displayPopin();

  return (
    <button
      type="button"
      onClick={() => display("tokens")}
      className="insite-ads-banner-card w-full max-w-[728px] rounded-2xl border border-white/40 bg-gradient-to-r from-[#ff6b6b] via-[#ff8f57] to-[#ffcc4d] px-6 py-4 text-left shadow-[0_18px_40px_rgba(255,125,64,0.35)] transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="insite-ads-banner-shine" />
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/80">
            <FormattedMessage id="ads_tokens_kicker" defaultMessage="Token boost" />
          </p>
          <h3 className="text-2xl font-black text-white sm:text-3xl">
            <FormattedMessage
              id="ads_tokens_title"
              defaultMessage="Reload your tokens in one tap"
            />
          </h3>
          <p className="text-sm text-white/90">
            <FormattedMessage
              id="ads_tokens_body"
              defaultMessage="Power up your chats and gifts with instant tokens."
            />
          </p>
        </div>
        <div className="mt-3 inline-flex items-center gap-2 self-start rounded-full bg-white px-5 py-2 text-sm font-bold text-[#ff6b6b] shadow-sm sm:mt-0 sm:self-center">
          <FormattedMessage id="ads_tokens_cta" defaultMessage="Get tokens" />
          <span aria-hidden>→</span>
        </div>
      </div>
    </button>
  );
}

export default TokensBanner;
